const NEWS = {

  el: null,
  ppp: 12, // Post per page
  pageNumber: null,
  loadMoreBtn: null,
  $loadMoreBtn: null,

  init() {
    this.el = document.querySelector('.news-listing');
    if (!this.el) return;
    this.pageNumber = document.querySelector('.news-listing').dataset.multiplier; //get page number based on data multiplier set on the block section
    this.loadMoreBtn = document.getElementById("loadmorenews");

    if (this.loadMoreBtn) {
      this.$loadMoreBtn = jQuery(this.loadMoreBtn);
      this.setListeners();
    }

  },

  setListeners() {
    this.loadMoreBtn.addEventListener('click', this.loadPosts.bind(this));
  },

  loadPosts() {
    this.pageNumber++;
    let str = '&pageNumber=' + this.pageNumber + '&ppp=' + this.ppp + '&action=more_post_ajax';

    jQuery.ajax({
      type: "POST",
      dataType: "html",
      url: ajax_posts.ajaxurl,
      data: str,

      beforeSend() {
        NEWS.$loadMoreBtn.text("Loading..."); // Change button text during load
      },

      success(response) {
        let $data = jQuery(response);
        if ($data.length) {
          jQuery("#downloadList").append($data);
          NEWS.$loadMoreBtn.text("Load more"); // reset text
        } else {
          NEWS.$loadMoreBtn.text("No more posts!"); // Change button text when end reached
          NEWS.$loadMoreBtn.addClass("hover:bg-orange cursor-not-allowed"); // Change button text when end reached
        }
        let pageUrl = '?pageNumber=' + NEWS.pageNumber;
        window.history.pushState('', '', pageUrl);
      },

    });

    return false;
  }
}


jQuery(document).ready(function () {
  NEWS.init();
});